import { getItem } from '@alltrails/session-storage/utils';

const isSessionSeoOrViralityTraffic = (): boolean => {
  const sessionAttribution = getItem<{ referring_domain?: string; virality_param?: string }>('sessionAttribution');

  if (!sessionAttribution) {
    return false;
  }

  const hasSeoTraffic = sessionAttribution.referring_domain?.includes('google') ?? false;
  const hasViralityTraffic = sessionAttribution.virality_param !== undefined;

  return hasSeoTraffic || hasViralityTraffic;
};

export default isSessionSeoOrViralityTraffic;
